<template>
  <v-form ref="promotionForm" v-model="valid">
    <v-layout style="width: 100%" row wrap>
      <v-flex xs12 pl-2>
        <v-layout pt-2 class="field-padding" row wrap>
          <v-flex xs6 md3 px-2>
            <v-text-field
              :error-messages="errorForField('name')"
              :rules="promotionRules.name"
              maxlength="50"
              v-model="promotion.name"
              label="Name"
              @input="resetError('name')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md5 px-2>
            <v-text-field
              :error-messages="errorForField('description')"
              :rules="promotionRules.description"
              maxlength="1000"
              v-model="promotion.description"
              label="Description"
              @input="resetError('description')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('user_description')"
              :rules="promotionRules.user_description"
              maxlength="1000"
              v-model="promotion.user_description"
              label="Description for User"
              @input="resetError('user_description')"
              :disabled="disabled"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pt-2 class="field-padding" xs12 pl-2>
        <v-divider class="mx-1"></v-divider>
        <v-layout pt-2 row wrap>
          <v-flex xs6 md4 px-2>
            <DateTimeInput
              :error-messages="errorForField('start_date')"
              :rules="promotionRules.start_date"
              v-model="promotion.start_date"
              :content="promotion.start_date"
              label="Start Date"
              @input="resetError('start_date')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <DateTimeInput
              :error-messages="errorForField('end_date')"
              :rules="promotionRules.end_date"
              v-model="promotion.end_date"
              :content="promotion.end_date"
              label="End Date"
              @input="resetError('end_date')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('code_lifespan_days')"
              :rules="promotionRules.code_lifespan_days"
              v-model="promotion.code_lifespan_days"
              type="number"
              step="1"
              label="Code Lifespan"
              hint="Enter lifespan in days"
              @input="resetError('code_lifespan_days')"
              :disabled="disabled"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pt-2 class="field-padding" xs12 pl-2>
        <v-layout pt-2 pb-2 row wrap>
          <v-flex xs6 md4 px-2>
            <v-select
              :error-messages="errorForField('discount_type')"
              :rules="promotionRules.discount_type"
              v-model="promotion.discount_type"
              :items="discountTypes"
              item-text="name"
              item-value="key"
              label="Discount Type"
              @input="resetError('discount_type')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2 v-if="promotion.discount_type == 'percentage'">
            <v-text-field
              :error-messages="errorForField('discount_percentage')"
              :rules="promotionRules.discount_percentage"
              v-model="promotion.discount_percentage"
              type="number"
              step="0.1"
              suffix="%"
              label="Discount Percentage"
              @input="resetError('discount_percentage')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2 v-if="promotion.discount_type == 'fixed_amount'">
            <v-text-field
              :error-messages="errorForField('discount_fixed')"
              :rules="promotionRules.discount_fixed"
              v-model="promotion.discount_fixed"
              type="number"
              class="noStepNumber"
              step="1"
              prefix="£"
              label="Discount Amount"
              hint="Enter amount in pounds"
              @input="resetError('discount_fixed')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('max_booking_cost_with_discount')"
              :rules="promotionRules.max_booking_cost_with_discount"
              v-model="promotion.max_booking_cost_with_discount"
              type="number"
              class="noStepNumber"
              step="1"
              prefix="£"
              label="Max Amount to Apply Discount To"
              hint="Enter amount in pounds"
              @input="resetError('max_booking_cost_with_discount')"
              :disabled="disabled"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="field-padding" xs12 pl-2>
        <v-divider class="mx-1"></v-divider>
        <v-layout pt-2 row wrap>
          <v-flex xs6 md4 px-2>
            <v-select
              :error-messages="errorForField('cost_absorbed_by')"
              :rules="promotionRules.cost_absorbed_by"
              v-model="promotion.cost_absorbed_by"
              :items="costAbsorbers"
              item-text="name"
              item-value="key"
              label="Cost Absorbed By"
              @input="resetError('cost_absorbed_by')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 pr-2 pt-2 pl-4>
            <v-checkbox
              :disabled="disabled || !allowMultipleEntryChange"
              v-model="promotion.allow_multiple_entries"
              color="primary"
              label="Allow Multiple Entries"
            />
          </v-flex>
          <v-flex xs12 md12 px-2 pb-2>
            <v-combobox
              multiple
              ref="promocodeInput"
              :error-messages="errorForField('codes')"
              @input="addCode($event)"
              :value="promotion.codes"
              label="Codes"
              append-icon
              hint="Press enter to add a code"
              :disabled="disabled"
            >
              <template slot="selection" slot-scope="{ item, parent, selected, index }">
                <v-chip
                  small
                  :close="item.new"
                  :disabled="!item.new"
                  @input="removeCode(index)"
                >{{ item.code }}</v-chip>
              </template>
            </v-combobox>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import DateTimeInput from "@/components/widget/input/DateTimeInput.vue";

export default {
  name: "promotion_form",
  components: {
    DateTimeInput
  },
  props: {
    promotion: Object,
    //discountTypes: Array,
    //costAbsorbers: Array,
    errors: { type: Object, default: () => {} },
    disabled: Boolean,
    allowMultipleEntryChange: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      valid: false,
      promotionRules: {
        name: [
          v => !!v || "Name is required",
          v => (v && v.length <= 50) || "Name cannot exceed 8 characters"
        ],
        description: [
          v => !!v || "Description is required",
          v =>
            (v && v.length <= 1000) ||
            "Description cannot exceed 1000 characters"
        ],
        user_description: [
          v => !!v || "Description for user is required",
          v =>
            (v && v.length <= 1000) ||
            "Description for user cannot exceed 1000 characters"
        ],
        start_date: [v => !!v || "Start date is required"],
        end_date: [v => !!v || "End date is required"],
        code_lifespan_days: [v => !!v || "Code lifespan is required"],
        discount_type: [v => !!v || "Discount type is required"],
        discount_percentage: [v => !!v || "Discount percentage is required"],
        discount_fixed: [v => !!v || "Discount amount is required"],
        max_booking_cost_with_discount: [v => !!v || "Max amount is required"],
        cost_absorbed_by: [v => !!v || "Cost absorbed by is required"]
      },
      discountTypes: [
        { name: "Percentage", key: "percentage" },
        { name: "Fixed Amount", key: "fixed_amount" }
      ],
      costAbsorbers: [
        { name: "Company", key: "company" },
        { name: "Driver", key: "driver" }
      ]
    };
  },
  methods: {
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        switch (field) {
          case "start_date":
            this.errors["end_date"] = "";
            break;
          case "end_date":
            this.errors["start_date"] = "";
            break;
        }
        if (this.errors[field] != []) {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function() {
      this.$refs.promotionForm.validate();
    },
    addCode: function(newCodes) {
      const pos = this.$refs.promocodeInput.selectionStart - 1;
      let self = this;
      let updatedCodes = [];

      this.promotion.codes.forEach(function(promocode) {
        if (typeof promocode == "object" && !promocode.new) {
          updatedCodes.push(promocode);
        }
      });

      newCodes.forEach(function(promocode) {
        if (typeof promocode == "object" && promocode.new) {
          updatedCodes.push(promocode);
        } else if (typeof promocode == "string") {
          updatedCodes.push({
            code: promocode,
            new: true
          });
        }
      });
      this.promotion.codes = updatedCodes;
      this.$nextTick(() => {
        self.$refs.promocodeInput.selectionEnd = pos;
      });
      this.resetError("codes");
    },
    removeCode: function(index) {
      const pos = this.$refs.promocodeInput.selectionStart - 1;
      let self = this;

      this.promotion.codes.splice(index, 1);
      this.$nextTick(() => {
        self.$refs.promocodeInput.selectionEnd = pos;
      });
      this.resetError("codes");
    },
    doNothing: function() {}
  },
  watch: {
    disabled: function() {
      this.$refs.promotionForm.reset();
    },
    valid: function() {
      this.$emit("validityChange", this.valid);
    }
  }
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>